import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess200120SuSaSkSoBuPeriStatus: 'idle',
    startProcess200120SuSaSkSoBuPeriError: undefined as any,
    loadUserParamsProcess200120SuSaSkSoBuPeriStatus: 'idle',
    loadUserParamsProcess200120SuSaSkSoBuPeriError: undefined as any,

    process200120SuSaSkSoBuPeriList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess200120SuSaSkSoBuPeri = createAsyncThunk('process200120SuSaSkSoBuPeriSlice/startProcess200120SuSaSkSoBuPeri', async ({ process200120SuSaSkSoBuPeri }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess200120SuSaSkSoBuPeri/`,
        prepareData(process200120SuSaSkSoBuPeri),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess200120SuSaSkSoBuPeriStatus } = getState().process200120SuSaSkSoBuPeriSlice
        return startProcess200120SuSaSkSoBuPeriStatus !== 'pending'
    }
})

export const loadUserParamsProcess200120SuSaSkSoBuPeri = createAsyncThunk('process200120SuSaSkSoBuPeriSlice/loadUserParamsProcess200120SuSaSkSoBuPeri', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess200120SuSaSkSoBuPeri/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess200120SuSaSkSoBuPeriStatus } = getState().process200120SuSaSkSoBuPeriSlice
        return loadUserParamsProcess200120SuSaSkSoBuPeriStatus !== 'pending'
    }
})

const Process200120SuSaSkSoBuPeriSlice = createSlice({
    name: 'process200120SuSaSkSoBuPeriSlice',
    initialState,
    reducers: {
        resetstartProcess200120SuSaSkSoBuPeri: (state) => {
            state.job = undefined
            state.startProcess200120SuSaSkSoBuPeriError = undefined
        },
        resetstartProcess200120SuSaSkSoBuPeriError: (state) => {
            state.startProcess200120SuSaSkSoBuPeriError = undefined
        },
        resetloadUserParamsProcess200120SuSaSkSoBuPeri: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess200120SuSaSkSoBuPeriError = undefined
        },
        resetloadUserParamsProcess200120SuSaSkSoBuPeriError: (state) => {
            state.loadUserParamsProcess200120SuSaSkSoBuPeriError = undefined
        },
        removeFromProcess200120SuSaSkSoBuPeriListById: (state, action) => {
            state.process200120SuSaSkSoBuPeriList = state.process200120SuSaSkSoBuPeriList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess200120SuSaSkSoBuPeriListByIds: (state, action) => {
            state.process200120SuSaSkSoBuPeriList = state.process200120SuSaSkSoBuPeriList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process200120SuSaSkSoBuPeriList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess200120SuSaSkSoBuPeriStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process200120SuSaSkSoBuPeriList = []
            state.startProcess200120SuSaSkSoBuPeriStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess200120SuSaSkSoBuPeri.pending, (state) => {
            state.startProcess200120SuSaSkSoBuPeriStatus = 'pending'
            state.startProcess200120SuSaSkSoBuPeriError = undefined
        })
        builder.addCase(startProcess200120SuSaSkSoBuPeri.fulfilled, (state, action) => {
            state.startProcess200120SuSaSkSoBuPeriStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess200120SuSaSkSoBuPeri.rejected, (state, action) => {
            state.startProcess200120SuSaSkSoBuPeriStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess200120SuSaSkSoBuPeriError = action.error.message
            } else {
                state.startProcess200120SuSaSkSoBuPeriError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess200120SuSaSkSoBuPeri.pending, (state) => {
            state.loadUserParamsProcess200120SuSaSkSoBuPeriStatus = 'pending'
            state.loadUserParamsProcess200120SuSaSkSoBuPeriError = undefined
        })
        builder.addCase(loadUserParamsProcess200120SuSaSkSoBuPeri.fulfilled, (state, action) => {
            state.loadUserParamsProcess200120SuSaSkSoBuPeriStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess200120SuSaSkSoBuPeri.rejected, (state, action) => {
            state.loadUserParamsProcess200120SuSaSkSoBuPeriStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess200120SuSaSkSoBuPeriError = action.error.message
            } else {
                state.loadUserParamsProcess200120SuSaSkSoBuPeriError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess200120SuSaSkSoBuPeri,
    resetstartProcess200120SuSaSkSoBuPeriError,
    resetloadUserParamsProcess200120SuSaSkSoBuPeri,
    resetloadUserParamsProcess200120SuSaSkSoBuPeriError,
    removeFromProcess200120SuSaSkSoBuPeriListById,
    removeFromProcess200120SuSaSkSoBuPeriListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process200120SuSaSkSoBuPeriSlice.actions
export default Process200120SuSaSkSoBuPeriSlice.reducer
